/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface ModelCharacteristics
 */
export interface ModelCharacteristics {
  /**
   *
   * @type {object}
   * @memberof ModelCharacteristics
   */
  data: object;
}

/**
 * Check if a given object implements the ModelCharacteristics interface.
 */
export function instanceOfModelCharacteristics(value: object): value is ModelCharacteristics {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function ModelCharacteristicsFromJSON(json: any): ModelCharacteristics {
  return ModelCharacteristicsFromJSONTyped(json, false);
}

export function ModelCharacteristicsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ModelCharacteristics {
  if (json == null) {
    return json;
  }
  return {
    data: json['data']
  };
}

export function ModelCharacteristicsToJSON(value?: ModelCharacteristics | null): any {
  if (value == null) {
    return value;
  }
  return {
    data: value['data']
  };
}
